<!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"> -->
<div class="allocation-pagination-wrap">
    <mat-paginator
        [selectConfig]="{ panelClass: 'allocation-paginator' }"
        [length]="uploadHistory.length"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
    >
    </mat-paginator>
</div>

<table mat-table [dataSource]="dataSource" class="mat-table mat-table-wrapper">
    <ng-container matColumnDef="event">
        <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.LOADER' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
            {{ element.event }}
        </td>
    </ng-container>

    <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.DATE_TIME' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
            {{ element.createdDate | customDateTimeFormat }}
        </td>
    </ng-container>
    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.TYPE' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
            {{ element.type }}
        </td>
    </ng-container>

    <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.USER_NAME' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
            {{ element.user }}
        </td>
    </ng-container>
    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.STATUS' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
            {{ element.status }}
        </td>
    </ng-container>
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ACTION' | transloco }}</th>
        <td mat-cell *matCellDef="let element">
            {{ element.action }}
            <a
                class="link-container"
                href="javascript:void(0)"
                #tooltip="matTooltip"
                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DOWNLOAD_UPLOADED_FILE' | transloco }}"
                [matTooltipPosition]="tooltip_position"
                (click)="DownloadFiles(element.fileSource)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24" />
                        <rect
                            fill="#000000"
                            opacity="0.3"
                            transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                            x="11"
                            y="1"
                            width="2"
                            height="12"
                            rx="1"
                        />
                        <path
                            d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            opacity="0.3"
                        />
                        <path
                            d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                        />
                    </g>
                </svg>
            </a>
            <a
                class="link-container"
                href="javascript:void(0)"
                #tooltip="matTooltip"
                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.DOWNLOAD_LOG_FILE' | transloco }}"
                *ngIf="element?.fileOutput"
                [matTooltipPosition]="tooltip_position"
                (click)="DownloadFiles(element.fileOutput)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24" />
                        <rect
                            fill="#000000"
                            opacity="0.3"
                            transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                            x="11"
                            y="1"
                            width="2"
                            height="12"
                            rx="1"
                        />
                        <path
                            d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                            opacity="0.3"
                        />
                        <path
                            d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                        />
                    </g>
                </svg>
            </a>
            <!-- <a href="javascript:void(0)" #tooltip="matTooltip" matTooltip="View" [matTooltipPosition]="tooltip_position">
                <i class="fa fa-eye" aria-hidden="true" style="margin: 0px 10px; position: relative; top: 3px"></i>
            </a>-->
            <!-- <a href="javascript:void(0)" #tooltip="matTooltip" matTooltip="Reload"
                [matTooltipPosition]="tooltip_position">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                    height="24px" viewBox="0 0 24 24" version="1.1">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g>
                            <polygon points="0 0 24 0 24 24 0 24" />
                        </g>
                        <path
                            d="M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z"
                            fill="#000000" fill-rule="nonzero" opacity="0.3"
                            transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) " />
                    </g>
                </svg>
            </a> -->
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
